import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/city/cities.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getCities = (_0) => __async(null, [_0], function* ({ lang, country }) {
  var _a;
  try {
    const locale = getLocaleOnly(lang);
    const data = yield fetchClient({
      url: `/cities/${country}?lang=${locale}`
    });
    if (((_a = data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const msg = Object.values((data == null ? void 0 : data.error) || {})[0] || (data == null ? void 0 : data.error);
      throw new Error(String(msg));
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getCitiesException"
    });
  }
});
var getPaginatedCities = (_0) => __async(null, [_0], function* ({
  lang,
  search,
  country,
  page,
  per_page
}) {
  try {
    const params = new URLSearchParams();
    if (country) params.append("country", country);
    if (search) params.append("city_name", search);
    if (page) params.append("page", page.toString());
    if (per_page) params.append("per_page", per_page.toString());
    params.append("lang", getLocaleOnly(lang));
    const data = yield fetchClient({
      url: `/cities?${params.toString()}`
    });
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getPaginatedCitiesException"
    });
  }
});

export {
  getCities,
  getPaginatedCities
};
//# sourceMappingURL=chunk-FM76CYXU.mjs.map